import PaginationContainer from "../../components/bonusUi/pagination";

const Pagination = () => {
  return <PaginationContainer />;
};

export default Pagination;
